import { CurrencyRate } from "./CurrencyRate.interface";

export const currencyData: CurrencyRate[] = [
  { name: "Kuwaiti Dinar", icon: "twemoji:flag-kuwait", sell: "162.98 EGP", buy: "157.98 EGP" },
  { name: "Saudi Riyal", icon: "twemoji:flag-saudi-arabia", sell: "13.07 EGP", buy: "12.87 EGP" },
  { name: "Euro", icon: "twemoji:flag-european-union", sell: "57.17 EGP", buy: "56.67 EGP" },
  { name: "Emirati Dirham", icon: "twemoji:flag-united-arab-emirates", sell: "13.34 EGP", buy: "13.14 EGP" },
  { name: "Qatari Riyal", icon: "twemoji:flag-qatar", sell: "13.47 EGP", buy: "13.27 EGP" },
  { name: "US Dollar", icon: "twemoji:flag-united-states", sell: "48.50 EGP", buy: "48.22 EGP" },
];